/**
 * Program Signup Popup
 * 3-step flow: goal → email (Klaviyo LssvmQ) → success → PDP redirect
 */
(function () {
  'use strict';

  var STORAGE = {
    submitted: 'fitaz_program_popup_submitted',
    ctaClicked: 'fitaz_program_popup_cta_clicked',
    dismissedAt: 'fitaz_program_popup_dismissed_at'
  };

  var GOAL_PDP = {
    weight_loss: '/products/weightloss-reset',
    strength: '/products/strength-and-tone',
    pregnancy: '/products/pregnancy-program',
    after_baby: '/products/transform-postpartum',
    not_sure: '/collections/guides'
  };

  var GOAL_PHRASE = {
    weight_loss: 'weight loss',
    strength: 'strength',
    pregnancy: 'pregnancy',
    after_baby: 'postpartum',
    not_sure: 'finding where to start'
  };

  var GOAL_HEADING = {
    weight_loss: { before: 'your ', after: ' goals' },
    strength: { before: 'your ', after: ' goals' },
    pregnancy: { before: 'your ', after: ' journey' },
    after_baby: { before: 'your ', after: ' goals' },
    not_sure: { before: '', after: '' }
  };

  var GOAL_OFFER = {
    weight_loss: 'Weight Loss Reset',
    strength: 'Strength & Tone',
    pregnancy: 'Pregnancy',
    after_baby: 'Postpartum',
    not_sure: ''
  };

  var STEP_NAMES = {
    1: 'goal_select',
    2: 'email_capture',
    3: 'success'
  };

  function sendGA4(eventName, params) {
    params = params || {};
    params.quiz_name = 'program_signup_popup';
    try {
      if (typeof window.gtag === 'function') {
        window.gtag('event', eventName, params);
        return;
      }
      window.dataLayer = window.dataLayer || [];
      var payload = { event: eventName };
      for (var k in params) {
        if (Object.prototype.hasOwnProperty.call(params, k)) payload[k] = params[k];
      }
      window.dataLayer.push(payload);
    } catch (e) {}
  }

  function lsGet(key) {
    try {
      return localStorage.getItem(key);
    } catch (e) {
      return null;
    }
  }

  function lsSet(key, value) {
    try {
      localStorage.setItem(key, value);
    } catch (e) {}
  }

    var DEFAULT_EXCLUSIONS = [
      '/cart',
      '/checkouts/',
      '/products/transform-level-1-free-trial',
      '/pages/join',
      '/a/loop_subscriptions/',
      '/pages/transform-bodytype-quiz',
      '/policies/',
      '/pages/faqs',
      '/products/platinum-membership',
      '/products/platinum-membership-4-monthly',
      '/products/platinum-membership-30off',
      '/products/reset-and-reward-challenge',
      '/products/personal-coaching',
      '/pages/personalcoachingcustomerdashboard',
      '/pages/waitlist-personalcoaching',
      '/pages/platinumgiveaway',
      '/pages/blackfriday-vip-list',
      '/pages/equipment-upsell',
      '/products/nutrition-consult',
      '/pages/choose-1-1-service',
      '-type',
      '/pages/booking-page',
      '/pages/choose-plan',
      '/adele',
      '/products/mothers-day-2-months-free-access',
      'aca=6a2631c869976f090420cc2a',
      '/products/perimenopause',
      '/pages/perimenopause-quiz',
      '?new-quiz'
    ];

    function parseExclusions(raw) {
      if (!raw || !String(raw).trim()) return DEFAULT_EXCLUSIONS.slice();
      return String(raw)
        .split(/\r?\n/)
        .map(function (line) {
          return line.trim().toLowerCase();
        })
        .filter(Boolean);
    }

  function isExcluded(patterns) {
    var href = (window.location.href || '').toLowerCase();
    var path = (window.location.pathname || '').toLowerCase();
    var search = (window.location.search || '').toLowerCase();
    var haystack = href + ' ' + path + ' ' + search;

    for (var i = 0; i < patterns.length; i++) {
      var p = patterns[i];
      if (!p) continue;
      if (href.indexOf(p) !== -1 || path.indexOf(p) !== -1 || search.indexOf(p) !== -1 || haystack.indexOf(p) !== -1) {
        return true;
      }
    }
    return false;
  }

  function shouldNeverShow() {
    return !!lsGet(STORAGE.submitted) || !!lsGet(STORAGE.ctaClicked);
  }

  function isWithinDismissWindow(days) {
    var raw = lsGet(STORAGE.dismissedAt);
    if (!raw) return false;
    var ts = parseInt(raw, 10);
    if (!ts || isNaN(ts)) return false;
    var ms = Math.max(1, days || 10) * 24 * 60 * 60 * 1000;
    return Date.now() - ts < ms;
  }

  function markDismissed() {
    lsSet(STORAGE.dismissedAt, String(Date.now()));
  }

  function markSubmitted() {
    lsSet(STORAGE.submitted, '1');
  }

  function markCtaClicked() {
    lsSet(STORAGE.ctaClicked, '1');
  }

  function pdpForGoal(goal) {
    return GOAL_PDP[goal] || GOAL_PDP.not_sure;
  }

  function subscribeToKlaviyo(opts) {
    var email = opts.email;
    var firstName = opts.firstName;
    var goal = opts.goal;
    var pdpUrl = opts.pdpUrl;
    var listId = opts.listId || 'LssvmQ';

    try {
      window._learnq = window._learnq || [];
      window._learnq.push([
        'identify',
        {
          $email: email,
          $first_name: firstName,
          first_name: firstName,
          program_goal: goal,
          recommended_pdp_url: pdpUrl
        }
      ]);
    } catch (err) {}

    var formData = new FormData();
    formData.append('g', listId);
    formData.append('email', email);
    formData.append('first_name', firstName);
    formData.append('$fields', 'first_name,program_goal,recommended_pdp_url');
    formData.append('program_goal', goal);
    formData.append('recommended_pdp_url', pdpUrl);
    formData.append('$source', 'Program Signup Popup');
    formData.append('$consent', 'web');

    return fetch('https://manage.kmail-lists.com/ajax/subscriptions/subscribe', {
      method: 'POST',
      body: formData,
      mode: 'no-cors'
    });
  }

  function init(root) {
    if (!root || root.getAttribute('data-psp-ready') === '1') return;
    root.setAttribute('data-psp-ready', '1');

    var listId = root.getAttribute('data-klaviyo-list') || 'LssvmQ';
    var delayMs = parseInt(root.getAttribute('data-delay-ms'), 10);
    if (isNaN(delayMs) || delayMs < 5000) delayMs = 6000;
    if (delayMs > 7000) delayMs = 7000;
    var scrollPercent = parseInt(root.getAttribute('data-scroll-percent'), 10);
    if (isNaN(scrollPercent) || scrollPercent < 1) scrollPercent = 30;
    var dismissDays = parseInt(root.getAttribute('data-dismiss-days'), 10);
    if (isNaN(dismissDays) || dismissDays < 1) dismissDays = 10;
    var suppressCredit = root.getAttribute('data-suppress-credit') === '1';
    var exclusions = parseExclusions(root.getAttribute('data-exclusions') || '');

    if (shouldNeverShow()) return;
    if (isWithinDismissWindow(dismissDays)) return;
    if (isExcluded(exclusions)) return;

    var overlay = root.querySelector('[data-psp-overlay]');
    var closeBtns = root.querySelectorAll('[data-psp-close]');
    var steps = {
      1: root.querySelector('[data-psp-step="1"]'),
      2: root.querySelector('[data-psp-step="2"]'),
      3: root.querySelector('[data-psp-step="3"]')
    };
    var mediaGoal = root.querySelector('[data-psp-media-goal]');
    var mediaSuccess = root.querySelector('[data-psp-media-success]');
    var goalError = root.querySelector('[data-psp-goal-error]');
    var formError = root.querySelector('[data-psp-form-error]');
    var nextGoalBtn = root.querySelector('[data-psp-next-goal]');
    var form = root.querySelector('[data-psp-form]');
    var firstNameInput = root.querySelector('[data-psp-first-name]');
    var emailInput = root.querySelector('[data-psp-email]');
    var nameField = root.querySelector('[data-psp-field-name]');
    var emailField = root.querySelector('[data-psp-field-email]');
    var submitBtn = root.querySelector('[data-psp-submit]');
    var chooseBtn = root.querySelector('[data-psp-choose-program]');
    var goalInputs = root.querySelectorAll('[data-psp-goal]');
    var step2Heading = root.querySelector('[data-psp-step2-heading]');
    var step2Text = root.querySelector('[data-psp-step2-text]');

    var currentStep = 1;
    var selectedGoal = '';
    var lastFocus = null;
    var opened = false;
    var impressionFired = false;

    function getSelectedGoal() {
      for (var i = 0; i < goalInputs.length; i++) {
        if (goalInputs[i].checked) return goalInputs[i].value;
      }
      return '';
    }

    function goalPhrase(goal) {
      return GOAL_PHRASE[goal] || GOAL_PHRASE.not_sure;
    }

    function goalOffer(goal) {
      return GOAL_OFFER[goal] || GOAL_OFFER.not_sure;
    }

    function updateStep2Copy(goal) {
      var phrase = goalPhrase(goal);
      var program = goalOffer(goal);
      var headingParts = GOAL_HEADING[goal] || GOAL_HEADING.not_sure;
      if (step2Heading) {
        step2Heading.innerHTML =
          'Great — we can definitely help you with ' +
          (headingParts.before || '') +
          '<em class="psp__accent">' +
          phrase +
          '</em>' +
          (headingParts.after || '') +
          '.';
      }
      if (step2Text) {
        var offerHtml =
          goal === 'not_sure'
            ? 'To help you get started, we\u2019d also love to give you <strong>$30 off</strong> as you explore our programs.'
            : 'To help you get started, we\u2019d also love to give you <strong>$30 off ' +
              program +
              '</strong>.';
        step2Text.innerHTML =
          offerHtml +
          ' You\u2019ll be joining more than 200,000 women who\u2019ve started their journey with Transform, so you\u2019re in good hands.';
      }
    }

    function successCtaLabel(goal) {
      if (goal === 'not_sure') return "TAKE ME TO PROGRAMS' COLLECTION";
      return 'TAKE ME TO MY PROGRAM';
    }

    function updateSuccessCta() {
      if (!chooseBtn) return;
      chooseBtn.textContent = successCtaLabel(selectedGoal || getSelectedGoal());
    }

    function showStep(n) {
      currentStep = n;
      for (var key in steps) {
        if (!Object.prototype.hasOwnProperty.call(steps, key)) continue;
        var el = steps[key];
        if (!el) continue;
        if (String(key) === String(n)) el.hidden = false;
        else el.hidden = true;
      }
      if (mediaGoal) mediaGoal.hidden = n === 3;
      if (mediaSuccess) mediaSuccess.hidden = n !== 3;
      if (n === 3) updateSuccessCta();

      sendGA4('program_popup_step_view', {
        step: n,
        step_name: STEP_NAMES[n] || String(n),
        program_goal: selectedGoal || undefined
      });
    }

    function open() {
      if (opened || shouldNeverShow()) return false;
      if (isWithinDismissWindow(dismissDays)) return false;
      opened = true;
      lastFocus = document.activeElement;
      root.hidden = false;
      root.setAttribute('aria-hidden', 'false');
      document.body.classList.add('psp-open');

      if (suppressCredit) {
        try {
          sessionStorage.setItem('tfkCpShown', '1');
        } catch (e) {}
      }

      showStep(1);

      if (!impressionFired) {
        impressionFired = true;
        sendGA4('program_popup_impression', { step: 1 });
      }

      var firstRadio = root.querySelector('[data-psp-goal]');
      if (firstRadio) firstRadio.focus();
      return true;
    }

    function close(opts) {
      opts = opts || {};
      root.hidden = true;
      root.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('psp-open');
      if (!opts.skipDismissMark && !lsGet(STORAGE.submitted) && !lsGet(STORAGE.ctaClicked)) {
        markDismissed();
      }
      if (lastFocus && typeof lastFocus.focus === 'function') {
        try {
          lastFocus.focus();
        } catch (e) {}
      }
    }

    goalInputs.forEach(function (input) {
      input.addEventListener('change', function () {
        selectedGoal = input.value;
        if (goalError) goalError.hidden = true;
        sendGA4('program_popup_goal_select', { program_goal: selectedGoal, step: 1 });
      });
    });

    if (nextGoalBtn) {
      nextGoalBtn.addEventListener('click', function () {
        selectedGoal = getSelectedGoal();
        sendGA4('program_popup_click', {
          button_label: 'GET $30 OFF YOUR PROGRAM',
          step: 1,
          program_goal: selectedGoal || undefined
        });
        if (!selectedGoal) {
          if (goalError) goalError.hidden = false;
          return;
        }
        if (goalError) goalError.hidden = true;
        updateStep2Copy(selectedGoal);
        showStep(2);
        if (firstNameInput) firstNameInput.focus();
      });
    }

    function clearFormErrors() {
      if (formError) formError.hidden = true;
      if (nameField) nameField.classList.remove('is-error');
      if (emailField) emailField.classList.remove('is-error');
    }

    if (firstNameInput) firstNameInput.addEventListener('input', clearFormErrors);
    if (emailInput) emailInput.addEventListener('input', clearFormErrors);

    if (form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        clearFormErrors();

        var firstName = firstNameInput ? String(firstNameInput.value || '').trim() : '';
        var email = emailInput ? String(emailInput.value || '').trim() : '';
        selectedGoal = selectedGoal || getSelectedGoal();
        var pdpUrl = pdpForGoal(selectedGoal);

        var invalid = false;
        if (!firstName) {
          if (nameField) nameField.classList.add('is-error');
          invalid = true;
        }
        if (!email || email.indexOf('@') === -1) {
          if (emailField) emailField.classList.add('is-error');
          invalid = true;
        }
        if (!selectedGoal) {
          invalid = true;
        }
        if (invalid) {
          if (formError) formError.hidden = false;
          return;
        }

        sendGA4('program_popup_email_submit', {
          program_goal: selectedGoal,
          step: 2
        });
        sendGA4('program_popup_click', {
          button_label: 'CLAIM YOUR DISCOUNT',
          step: 2,
          program_goal: selectedGoal
        });

        if (submitBtn) {
          submitBtn.disabled = true;
          submitBtn.setAttribute('aria-busy', 'true');
        }

        function goSuccess() {
          markSubmitted();
          sendGA4('program_popup_complete', {
            program_goal: selectedGoal,
            recommended_pdp_url: pdpUrl,
            step: 3
          });
          showStep(3);
          if (chooseBtn) chooseBtn.focus();
        }

        subscribeToKlaviyo({
          email: email,
          firstName: firstName,
          goal: selectedGoal,
          pdpUrl: window.location.origin + pdpUrl,
          listId: listId
        })
          .then(goSuccess)
          .catch(goSuccess)
          .finally(function () {
            if (submitBtn) {
              submitBtn.disabled = false;
              submitBtn.removeAttribute('aria-busy');
            }
          });
      });
    }

    if (chooseBtn) {
      chooseBtn.addEventListener('click', function () {
        selectedGoal = selectedGoal || getSelectedGoal();
        var pdpUrl = pdpForGoal(selectedGoal);
        var ctaLabel = successCtaLabel(selectedGoal);
        sendGA4('program_popup_cta_click', {
          program_goal: selectedGoal,
          link_url: pdpUrl,
          step: 3
        });
        sendGA4('program_popup_click', {
          button_label: ctaLabel,
          step: 3,
          program_goal: selectedGoal
        });
        markCtaClicked();
        markSubmitted();
        window.location.href = pdpUrl;
      });
    }

    function onCloseClick() {
      sendGA4('program_popup_click', {
        button_label: 'close',
        step: currentStep,
        program_goal: selectedGoal || undefined
      });
      close();
    }

    closeBtns.forEach(function (btn) {
      btn.addEventListener('click', onCloseClick);
    });
    if (overlay) {
      overlay.addEventListener('click', onCloseClick);
    }

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !root.hidden) {
        sendGA4('program_popup_click', {
          button_label: 'escape',
          step: currentStep,
          program_goal: selectedGoal || undefined
        });
        close();
      }
    });

    var triggerTimer = null;
    var triggerFired = false;

    function cleanupTrigger() {
      window.removeEventListener('scroll', onScroll);
      if (triggerTimer) {
        clearTimeout(triggerTimer);
        triggerTimer = null;
      }
    }

    function tryOpenFromTrigger() {
      if (triggerFired) return;
      triggerFired = true;
      cleanupTrigger();
      open();
    }

    function onScroll() {
      var docHeight =
        Math.max(document.body.scrollHeight, document.documentElement.scrollHeight) -
        window.innerHeight;
      if (docHeight <= 0) return;
      var y = window.pageYOffset || document.documentElement.scrollTop || 0;
      if ((y / docHeight) * 100 < scrollPercent) return;
      tryOpenFromTrigger();
    }

    triggerTimer = setTimeout(tryOpenFromTrigger, delayMs);
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  function boot() {
    var roots = document.querySelectorAll('[data-program-signup-popup]');
    for (var i = 0; i < roots.length; i++) init(roots[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
